import { getSeo, seoHead } from './pages.mjs';
export function applySeo(route, doc = document) {
  const seo = getSeo(route.path, route.meta?.seoPublic === true);
  // Clear public metadata when navigating to a private or unknown route.
  doc.head.querySelectorAll('title, meta[name="description"], meta[name="keywords"], meta[name="robots"], link[rel="canonical"], meta[property^="og:"], meta[name^="twitter:"]').forEach(node => node.remove());
  const template = doc.createElement('template');
  template.innerHTML = seoHead(seo);
  doc.head.appendChild(template.content);
  doc.documentElement.lang = 'de';
}
export function installRouterSeo(router) {
  // Set metadata before Vue mounts, including for a directly opened private URL.
  applySeo(router.resolve(window.location.pathname));
  return router.afterEach((to, _from, failure) => { if (!failure) applySeo(to); });
}
